export default function reducer(
  state = {
    showcase: {},
    landing: null,
    entry: null,
    article: null,
    navigation: [],
    loading: true,
    loaded: false,
    error: null,
    tags: null,
    projects: null,
  },
  action,
) {
  switch (action.type) {
    /*case LOCATION_CHANGE: {
        console.log('location change')
        return {...state, data: [] }
      }*/

    case 'GETTING_HOME': {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case 'GOT_HOME': {
      return {
        ...state,
        loading: false,
        loaded: true,
        showcase: action.payload,
      };
    }

    case 'GOT_ARCHIVE': {
      return {
        ...state,
        tags: action.payload,
      };
    }

    case 'GOT_NEW_ARCHIVE': {
      return {
        ...state,
        projects: action.payload,
      };
    }

    case 'GETTING_PAGE': {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case 'GETTING_LANDING_PAGE': {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case 'GOT_PAGE': {
      return {
        ...state,
        loading: false,
        loaded: true,
        entry: action.payload,
      };
    }
    case 'GOT_LANDING_PAGE': {
      return {
        ...state,
        loading: false,
        loaded: true,
        landing: action.payload,
      };
    }
    case 'GETTING_ARTICLE': {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case 'GOT_ARTICLE': {
      return {
        ...state,
        loading: false,
        loaded: true,
        article: action.payload,
      };
    }
    case 'CLEARING_ARTICLE': {
      return {
        ...state,
        loading: false,
        loaded: true,
        article: null,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/redux/reducers/Page.js